"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var Dialog_1 = __importDefault(require("@mui/material/Dialog"));
var DialogActions_1 = __importDefault(require("@mui/material/DialogActions"));
var DialogContent_1 = __importDefault(require("@mui/material/DialogContent"));
var DialogContentText_1 = __importDefault(require("@mui/material/DialogContentText"));
var DialogTitle_1 = __importDefault(require("@mui/material/DialogTitle"));
var react_1 = __importStar(require("react"));
require("../assets/styles/order.css");
var functions_1 = require("../interfaces/functions");
var statuses = [
    "Pending",
    "Paid",
    "Processing",
    "Shipped",
    "Delivered",
    "Cancelled",
    "Refunded",
    "On hold",
    "Backordered",
    "Partially shipped",
    "Payment declined",
];
function AdminOrder(props) {
    var _a = (0, react_1.useState)(null), anchorEl = _a[0], setAnchorEl = _a[1];
    var _b = react_1.default.useState(""), status = _b[0], setStatus = _b[1];
    var open = Boolean(anchorEl);
    var _c = react_1.default.useState(false), openbox = _c[0], setOpen = _c[1];
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var handleClickOpen = function () {
        setOpen(true);
    };
    var handleCloseConfirmation = function () {
        setOpen(false);
    };
    var handleChange = function (event) {
        event.preventDefault();
        setStatus(event.target.value);
        handleClickOpen();
    };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(material_1.Box, null,
            react_1.default.createElement(material_1.Box, { className: "ordercomp" },
                react_1.default.createElement(material_1.Typography, { component: "div", variant: "h5", fontSize: "small", color: "primary" },
                    "Owner: ",
                    props.userId),
                react_1.default.createElement(material_1.Typography, { component: "div", variant: "h5", fontSize: "small", color: "primary" },
                    "Date: ",
                    props.createdAt),
                react_1.default.createElement(material_1.Typography, { component: "div", variant: "h5", fontSize: "small", color: "primary" },
                    "Price: ",
                    props.amountPaid),
                react_1.default.createElement(material_1.Box, { sx: { minWidth: 120 } },
                    react_1.default.createElement(material_1.FormControl, { fullWidth: true },
                        react_1.default.createElement(material_1.InputLabel, { id: "demo-simple-select-label" }, props.status),
                        react_1.default.createElement(material_1.Select, { labelId: "demo-simple-select-label", id: "demo-simple-select", value: status, label: props.status, onChange: handleChange }, statuses.map(function (status) {
                            return (react_1.default.createElement(material_1.MenuItem, { key: status, value: status, onClick: function () { } }, status));
                        })))),
                react_1.default.createElement(material_1.Box, null,
                    react_1.default.createElement(material_1.Button, { variant: "outlined", "aria-label": "more", id: "long-button", "aria-controls": open ? "long-menu" : undefined, "aria-expanded": open ? "true" : undefined, "aria-haspopup": "true", onClick: handleClick }, "Products"),
                    react_1.default.createElement(material_1.Menu, { id: "long-menu", MenuListProps: {
                            "aria-labelledby": "long-button",
                        }, anchorEl: anchorEl, open: open, onClose: handleClose }, props.orderProducts.map(function (product) {
                        return (react_1.default.createElement(material_1.MenuItem, { key: product.productId, onClick: function () {
                                handleClickOpen();
                                handleClose();
                            } },
                            product.productName,
                            ": ",
                            product.productQuantity,
                            " X $",
                            product.price));
                    })))),
            react_1.default.createElement(material_1.Divider, null),
            react_1.default.createElement(Dialog_1.default, { open: openbox, onClose: handleCloseConfirmation, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description" },
                react_1.default.createElement(DialogTitle_1.default, { id: "alert-dialog-title" }, "Set order status"),
                react_1.default.createElement(DialogContent_1.default, null,
                    react_1.default.createElement(DialogContentText_1.default, { id: "alert-dialog-description" },
                        "Are you sure you want to update the status of ",
                        props.Orderid,
                        " to",
                        " ",
                        status)),
                react_1.default.createElement(DialogActions_1.default, null,
                    react_1.default.createElement(material_1.Button, { onClick: handleCloseConfirmation }, "Cancel"),
                    react_1.default.createElement(material_1.Button, { onClick: function () {
                            (0, functions_1.setOrderstatus)(props.Orderid, status);
                            handleCloseConfirmation();
                        } }, "yes"))))));
}
exports.default = AdminOrder;
